import Row from "@/components/Table/Row";
import { RowRendererProps } from "@/components/Table/Table";
import { BomItemCompare } from "@/pages/products/useProducts";
import tableStyles from "../../../../../components/Table/Table.module.scss";
import bomStyles from "../../../../products/detail/bom/BomRow.module.scss";

export interface BomRowRendererProps<R = BomItemCompare> extends RowRendererProps<R> {
  level?: number;
}

export default function BomRowCompare({
  record,
  columns,
  rowKey,
  selectedKeys,
  onChangeCheckbox,
  rowLink,
  gridTemplateColumns,
  level,
}: BomRowRendererProps<BomItemCompare>) {
  const children = record.children.sort((a, b) => (a.children.length > b.children.length ? 1 : -1));

  if (children.length > 0) {
    return (
      <div
        className={bomStyles["row-wrapper"]}
        style={{ paddingLeft: level || 0 ? "24px" : "0" }}
      >
        <div
          className={[tableStyles.row, bomStyles.part].join(" ")}
          key={Number(record[rowKey as keyof BomItemCompare])}
        >
          <div className={bomStyles.wrapper}>
            <span className={bomStyles["bom-name"]}>{record.name}</span>
            <span>{record.quantity}x</span>
          </div>
        </div>
        {children.map((child) => (
          <BomRowCompare
            key={Number(child[rowKey as keyof BomItemCompare])}
            {...{
              record: child,
              columns,
              rowLink,
              rowKey,
              gridTemplateColumns,
              selectedKeys,
              onChangeCheckbox,
              level: (level || 0) + 1,
            }}
          />
        ))}
      </div>
    );
  }
  return (
    <Row
      {...{
        className: record.changed ? bomStyles.changed : undefined,
        record,
        columns,
        rowKey,
        rowLink,
        gridTemplateColumns: columns
          .map((column) => {
            if (column.key === "name") {
              const width = 275 - (level || 1) * 24;
              return `minmax(${width}px, ${width}px)`;
            }
            return `minmax(${column.minWidth ? column.minWidth : "150px"}, ${
              column.maxWidth ? column.maxWidth : "1fr"
            })`;
          })
          .join(" "),
        selectedKeys,
        onChangeCheckbox,
      }}
    />
  );
}
